import { useMemo } from 'react'
import { View, XStack } from 'tamagui'

interface IQuestionWrapperProps {
  isSuccess?: boolean
  isError?: boolean
  isSelected?: boolean
  children: React.ReactNode
}

export function QuestionWrapper({
  children,
  isSuccess,
  isError,
  isSelected,
}: IQuestionWrapperProps) {
  const infoColor = useMemo(() => {
    if (isSuccess) return '$success-300'
    if (isError) return '$error-300'
    if (isSelected) return '$primary-300'
    return '$neutral-200'
  }, [isSuccess, isError, isSelected])

  return (
    <XStack alignItems="center" mb="$spacing-inset-nano">
      <View
        backgroundColor={infoColor}
        borderWidth={1}
        borderRightWidth={0}
        borderColor="$neutral-200"
        width={8}
        height={'100%'}
        borderTopLeftRadius="$border-radius-sm"
        borderBottomLeftRadius="$border-radius-sm"
      />
      <XStack
        borderWidth={1}
        borderLeftWidth={0}
        borderColor="$neutral-200"
        borderTopRightRadius="$border-radius-sm"
        borderBottomRightRadius="$border-radius-sm"
        flex={1}
        pl="$spacing-inset-nano"
      >
        {children}
      </XStack>
    </XStack>
  )
}
